import { MultilingualString } from "features/shared/types/string";

export interface SubProduct {
    id: string;
    name: MultilingualString;
    tags: string[]; // must at least be empty array
    properties: Record<string, Property>;
    image?: string;
    isHidden?: boolean;
}

export type Property =
    | TextProperty
    | FileDownloadProperty
    | ImageProperty
    | PromotionTagsProperty;

export enum PropertyType {
    Text = "Text",
    FileDownload = "FileDownload",
    Image = "Image",
    PromotionTags = "PromotionTags",
}

interface BaseProperty {
    accessor: string;
}

interface TextProperty extends BaseProperty {
    type: PropertyType.Text;
    value: MultilingualString;
}

interface FileDownloadProperty extends BaseProperty {
    type: PropertyType.FileDownload;
    value: string;
}

interface ImageProperty extends BaseProperty {
    type: PropertyType.Image;
    value: string;
}
interface PromotionTagsProperty extends BaseProperty {
    type: PropertyType.PromotionTags;
    value: string;
}
